import React, { useEffect, useRef, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";

import TipoDispositivoCRUD from "../TipoDispositivo/TipoDispositivoCRUD/TipoDispositivoCRUD"
import { getTipoDispositivo } from "../../../../API/IT/TipoDispositivos/TipoDispositivoRequest";
import { setTitlePage } from "../../../Services/Config/ConfigService";

const TipoDispositivoScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [dispositivos, setDispositivos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const tipoDispositivo = await getTipoDispositivo();
    setDispositivos(tipoDispositivo);
    setLoading(false);
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdTipoDispositivo",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Tipo Dispositivo",
      headerEn: "Type Device",
      field: "TipoDispositivo",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
        header: "Código Interno",
        headerEn: "Internal Code",
        field: "CodigoInterno"
      },
    {
      field: "IdTipoDispositivo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: dispositivos,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "tipoDisp", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "tipoDisp", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <TipoDispositivoCRUD
          listTipoDispositivos={dispositivos}
          toastRef={toast}
          tipoDispositivoDialog={showDialog}
          tipoDispositvo={selected}
          setTipoDispositivoDialog={setShowDialog}
          getPos={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default TipoDispositivoScreen;
